<template>
  <div class="layout-card">
    <b-row align-v="center">
      <b-col cols="10">
        <div class="d-flex align-items-center">
          <img alt="layout" width="32px" :src="require('@/assets/nuevoDashboard/agenda.svg')" class="mr-3">
          <div>
            <h6 class="mb-0 titulo-layout">Layout disponible</h6>
            <small class="subtitulo-layout">Descarga el formato oficial antes de cargar tu archivo</small>
          </div>
        </div>
      </b-col>
      <b-col cols="2" class="text-right">
        <b-button variant="outline-primary" size="sm" @click="$emit('descargar')" class="btn-descargar">
          <img alt="descargar" width="16px" :src="require('@/assets/icons/download.svg')">
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'LayoutCard'
}
</script>

<style scoped>
.layout-card {
  background: #008FFF;
  border-radius: 12px;
  padding: 1rem 1.5rem;
  box-shadow: 0 4px 15px rgba(0, 143, 255, 0.3);
}

.titulo-layout {
  color: #fff;
  font-weight: 600;
  font-size: 14px;
}

.subtitulo-layout {
  color: rgba(255, 255, 255, 0.85);
  font-size: 12px;
}

.btn-descargar {
  background: #71aeff;
  border-color: #0046A2;
  color: #fff;
  border-radius: 8px;
  padding: 0.5rem 1rem;
}

.btn-descargar:hover {
  background: #003882;
  border-color: #003882;
  color: #fff;
}
</style>